// 设置函数来为状态值的常量赋值
import * as types from './mutation-types'

export default {
  // 记录滚动高度
  [types.INSERT_SCROLLTOP] (state, payload) {
    state.projectDetail.map(x => {
      if (x.guid === payload.id) {
        x.scrollTop = payload.scrollTop
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js